const features = [
  {
    icon: 'ri-database-2-line',
    title: '海量片源',
    desc: '涵盖电影、电视剧、综艺、动漫、纪录片等全品类，超10万部资源持续扩充',
    color: 'primary',
  },
  {
    icon: 'ri-4k-line',
    title: '高清画质',
    desc: '全站支持1080P超清画质，智能码率自适应，流畅不卡顿',
    color: 'accent',
  },
  {
    icon: 'ri-rocket-2-line',
    title: '极速播放',
    desc: '全球智能CDN加速节点，点击即播无需等待，告别缓冲焦虑',
    color: 'primary',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新',
    desc: '同步各大平台热播内容，第一时间上线最新剧集与院线大片',
    color: 'accent',
  },
  {
    icon: 'ri-vip-crown-line',
    title: '完全免费',
    desc: '无需注册、无需会员、无隐藏收费，打开即看，纯净观影体验',
    color: 'primary',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            为什么选择<strong className="text-primary-500">90影院</strong>
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            五大核心优势，打造8090后最爱的免费观影平台
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {features.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/60 hover:border-background-300/60 transition-all duration-300 group cursor-default"
            >
              <div
                className={`w-11 h-11 rounded-lg flex items-center justify-center mb-4 ${
                  item.color === 'primary'
                    ? 'bg-primary-500/15 text-primary-500'
                    : 'bg-accent-500/15 text-accent-400'
                }`}
              >
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}